/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddDeviceGroupController($scope, $mdDialog, $log, $state, $stateParams, $document, $q, types, deviceGroupService,
                                                 networkSettingsService, apiLimitsService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {
            networkSettings: networkSettingsService.createDefaultNetworkSettings(),
            apiLimits: apiLimitsService.createDefaultApiLimits()
        };

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.add = add;
        vm.cancel = cancel;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        if (
            vm.entityTableConfiguration.scope === types.scope.subCustomer ||
            vm.entityTableConfiguration.scope === types.scope.customer
        ) {
            if ($stateParams.subCustomerId) {
                vm.entity.subCustomerId = {
                    entityType: types.entityType.subCustomer,
                    id: $stateParams.subCustomerId
                };
            }
        }

        var newNetworkSettings = vm.entity.networkSettings;
        var newApiLimits = vm.entity.apiLimits;
        deviceGroupService.saveDeviceGroup(vm.entity).then(
            (entity) => {
                vm.entity = entity;
                networkSettingsService.getNetworkSettings(entity.id.entityType, entity.id.id).then(
                    (networkSettings) => {
                        newNetworkSettings.entityId = networkSettings.entityId;
                        newNetworkSettings.id = networkSettings.id;
                        networkSettingsService.saveNetworkSettings(newNetworkSettings).then(
                            (networkSettings) => {
                                vm.entity.networkSettings = networkSettings;
                                apiLimitsService.getApiLimits(entity.id.entityType, entity.id.id).then(
                                    (apiLimits) => {
                                        newApiLimits.entityId = apiLimits.entityId;
                                        newApiLimits.id = apiLimits.id;
                                        apiLimitsService.saveApiLimits(newApiLimits).then(
                                            (apiLimits) => {
                                                vm.entity.apiLimits = apiLimits;
                                                $scope.theForm.$setPristine();
                                                $mdDialog.hide();
                                            }
                                        );
                                    }
                                );
                            }
                        );
                    }
                );
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/device-group/add-device-group.controller.js